<template>
  <div class="container">
    <swipe ref="swiper" class="container" @change="handleChange">
      <swipe-item
        v-for="(item, index) in processedData"
        class="image-swipe-item"
        :key="item.imagePath"
        @click="playToggle"
      >
        <video
          v-if="item.videoPath"
          :ref="`video-${index}`"
          width="100%"
          height="100%"
          type="video/mp4"
          preload="auto"
          muted
          :poster="item.imagePath"
          :src="item.videoPath"
          x5-playsinline=""
          playsinline=""
          webkit-playsinline=""
          @ended="(event) => handlePlayEnd(event, index)"
        ></video>
        <VanImage
          v-else
          width="100vw"
          :style="{ 'max-width': '100%' }"
          class="image-item"
          fit="contain"
          :src="item.imagePath"
          alt=""
        />
      </swipe-item>
      <template #indicator>
        <div class="indicator-container">
          <div
            v-for="(indicator, index) in processedData"
            :key="indicator.imagePath"
            class="indicator-item"
            :class="{
              'indicator-item--active': current >= index,
              'indicator-item--ml': index > 0,
            }"
            :style="{
              width: indicatorItemWidth,
            }"
          ></div>
        </div>
      </template>
    </swipe>
    <span class="video-play-btn" v-show="!playing" @click="playVideo"></span>
    <audio ref="audio" v-if="twMusic" loop :src="twMusic"></audio>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Image as VanImage } from "vant";

export default {
  components: {
    Swipe,
    SwipeItem,
    VanImage,
  },
  props: {
    twMusic: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: 0,
      timer: 0,
      playing: false,
    };
  },
  computed: {
    processedData() {
      return this.data.map((item) => {
        return {
          ...item,
          imagePath: item.imagePath + `&x-oss-process=image/format,png`,
        };
      });
    },
    indicatorItemWidth() {
      const total = 750;
      const paddingHorizontal = 44;
      const itemMargin = 8;
      const contentWidth = total - paddingHorizontal * 2;
      const itemWidth =
        (contentWidth - itemMargin * (this.processedData.length - 1)) /
        this.processedData.length;
      return `${itemWidth / 100}rem`;
    },
  },
  methods: {
    handleChange(index) {
      this.current = index;
    },
    handlePlayEnd() {
      this.$refs.swiper.next();
    },
    playToggle() {
      if (this.playing) {
        this.pauseVideo();
      } else {
        this.playVideo();
      }
    },
    playVideo() {
      this.$refs.audio.play();
      this.playing = true;
      if (this.processedData[this.current].videoPath) {
        const videoRef = this.$refs[`video-${this.current}`][0];
        videoRef.play();
      } else {
        this.timer = setTimeout(() => {
          this.$refs.swiper.next();
        }, 2000);
      }
    },
    pauseVideo() {
      this.$refs.audio.pause();
      this.playing = false;
      clearTimeout(this.timer);
      if (this.processedData[this.current].videoPath) {
        const videoRef = this.$refs[`video-${this.current}`][0];
        videoRef.pause();
      }
    },
  },
  watch: {
    current: {
      handler(index) {
        clearTimeout(this.timer);
        if (!this.playing) {
          return;
        }
        if (!this.processedData[index].videoPath) {
          this.timer = setTimeout(() => {
            this.$refs.swiper.next();
          }, 2000);
        } else {
          const videoRef = this.$refs[`video-${index}`][0];
          videoRef.play();
        }
      },
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}

.indicator-container {
  position: absolute;
  bottom: 2.48rem;
  width: 100%;
  display: flex;
  justify-content: center;
}

.video-play-btn {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: 1.32rem;
  height: 0.94rem;
  background-image: url("https://p4-ky.wsukwai.com/udata/pkg/kmovie/fontend-activity/video-play-btn.6ea6f4628f761a29.png");
  background-size: 100% 100%;
  display: inline-block;
  z-index: 1;
  opacity: 1;
}

.indicator-item {
  width: 0.64rem;
  height: 0.04rem;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 0.03rem;
  /* margin: 0 0.04rem; */
}

.indicator-item--active {
  background-color: rgba(255, 255, 255, 1);
}

.indicator-item--ml {
  margin-left: 0.08rem;
}

.image-swipe-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
